<template>
  <draggable
    :list="nodosInstancia"
    animation="500"
    :class="[isChild ? 'm-edition-map-contents-list m-edition-map-contents-list-child' : 'm-edition-map-contents-list']"
    :disabled="disabledDragg"
    fallback-class="display-none"
    :fallback-on-body="true"
    :force-fallback="true"
    ghost-class="m-edition-map-contents-list-item-ghost"
    :group="{ name: 'm-edition-map-contents-list', pull: true, put: false }"
    :invert-swap="true"
    :scroll="true"
    :scroll-sensitivity="50"
    tag="ul"
    @change="changeOrder"
  >
    <li
      v-for="nodo in nodosInstancia"
      :key="nodo.id"
      :id="`nodo-item-${nodo.id}`"
      :class="[{ 'm-edition-map-contents-list-item-drag': !disabledDragg }, 'm-edition-map-contents-list-item']"
    >
      <img
        v-if="nodo.icono"
        class="m-edition-map-contents-list-item-icon"
        :src="`/img/map-icons/${nodo.icono}`"
      >
      <div
        :id="`nodo-item-data-${nodo.id}`"
        :class="[!disabledSelected && nodo.id === $store.getters.getAssetSelectedNode.id
          ? 'm-edition-map-contents-list-item-data m-edition-map-contents-list-item-data-current'
          : 'm-edition-map-contents-list-item-data']"
        :style="`background-color: ${nodo.color}; border-color: ${nodo.color};`"
      >
        <a
          class="m-edition-map-contents-list-item-data-name"
          href="#"
          @click.prevent="toggleChildren(nodo.id, nodo.children.length)"
          :style="`color: ${nodo.colorNombre ? nodo.colorNombre : setTextColor(nodo.color)}`"
        >
          <i
            :id="`node-icon-circle-${nodo.id}`"
            class="fas fa-spinner fa-spin node-icon-loading"
          >
          </i>
          <i
            :id="`node-icon-caret-${nodo.id}`"
            :class="[nodo.children.length ? 'fas fa-caret-down' : 'fas fa-caret-right', 'node-icon-caret']"
          >
          </i>
          <i
            :id="`node-icon-move-${nodo.id}`"
            class="far fa-arrows-alt node-icon-move"
          >
          </i>
          <span>
            {{ nodo.nombre }}
            <small v-if="nodo.children.length">
              ({{ nodo.children.length }} {{ $t('mEditionMapPathTreeNodeFixed.steps') }})
            </small>
          </span>
        </a>
        <div :class="`m-edition-map-contents-list-item-data-actions-${nodeActionsClass}`">
          <MoleculeEditionMapPathTreeNodeActions
            :is="moleculeNodeActions"
            :contenido="contenido"
            :element="element"
            :info="info"
            :nodo="nodo"
            :parent="parent"
            @emitAction="emitAction"
          />
        </div>
      </div>
      <MoleculeEditionMapPathTreeNodeFixed
        v-if="nodo.children.length"
        :id="`child-${nodo.id}`"
        class="m-edition-map-contents-list-child"
        :contenido="contenido"
        :disabledDragg="disabledDragg"
        :disabledSelected="disabledSelected"
        :element="element"
        :info="info"
        :is-child="true"
        :node-actions="nodeActions"
        :node-actions-class="nodeActionsClass"
        :nodos="nodo.children"
        :parent="nodo"
        @emitAction="emitAction"
      />
    </li>
  </draggable>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'MoleculeEditionMapPathTreeNodeFixed',

  components: {
    draggable
  },

  props: {
    contenido: Object,

    disabledDragg: {
      type: Boolean,
      default: true
    },

    disabledSelected: {
      type: Boolean,
      default: true
    },

    element: Object,

    info: {
      type: Object,
      default: () => ({})
    },

    isChild: {
      type: Boolean,
      default: false
    },

    nodeActions: String,
    nodeActionsClass: String,
    nodos: Array,

    parent: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      moleculeNodeActions: '',
      nodosInstancia: [],
      previousSelectedNode: {}
    }
  },

  computed: {
    pickedColor () {
      return Object.assign({}, this.$store.getters.getEditorPickedColor)
    },

    pickedColorNombre () {
      return Object.assign({}, this.$store.getters.getEditorPickedColorNombre)
    },

    pickedIcon () {
      return Object.assign({}, this.$store.getters.getEditorPickedIcon)
    }
  },

  watch: {
    nodeActions: {

      handler () {
        this.moleculeNodeActions = () => import(`@/components/molecules/MoleculeEditionMapPathTreeNodeActions${this.nodeActions}`)
      },

      immediate: true
    },

    nodos () {
      this.setNodosInstancia()
    },

    pickedColor () {
      let index = this.nodosInstancia.findIndex(nodo => nodo.id === this.pickedColor.id)
      if (!this.parent && index !== -1) {
        this.nodosInstancia[index].color = this.pickedColor.color
      }
    },

    pickedColorNombre () {
      let index = this.nodosInstancia.findIndex(nodo => nodo.id === this.pickedColorNombre.id)
      if (!this.parent && index !== -1) {
        this.$set(this.nodosInstancia[index], 'colorNombre', this.pickedColorNombre.colorNombre)
      }
    },

    pickedIcon () {
      let index = this.nodosInstancia.findIndex(nodo => nodo.id === this.pickedIcon.id)
      if (index !== -1) {
        this.$set(this.nodosInstancia[index], 'icono', this.pickedIcon.icon)
      }
    }
  },

  created () {
    if (this.parent === null) {
      this.$store.commit('setAssetSelectedNode', Object.assign({}, this.nodos[0]))
    }
    this.setNodosInstancia()
  },

  methods: {
    changeOrder (event) {
      if (event.added || event.moved || event.removed) {
        let parent = this.parent ? this.parent.id : null
        let params = { action: 'changeOrder', event: event, nodos: this.nodosInstancia, parent: parent }
        this.$emit('emitAction', params)
      }
    },

    emitAction (params) {
      // TODO: Implementar switch para llamar a otros métodos en emit
      if (params.nodo) {
        this.$emit('emitAction', params)
      }
      if (params.action === 'changeOrder') {
        this.setChildren(params)
      }
    },

    setChildren (params) {
      let index = this.nodosInstancia.findIndex(nodo => nodo.id === params.parent)
      this.nodosInstancia[index].children = [...params.nodos]
      this.changeOrder(params.event)
    },

    setNodosInstancia () {
      this.nodosInstancia = [...this.nodos]
      this.nodosInstancia.forEach(nodo => {
        nodo = Object.assign({}, nodo)
        if (!this.isChild && !nodo.colorNombre) {
          this.$set(nodo, 'colorNombre', this.setTextColor(nodo.color))
        }
        nodo.children = [...nodo.children]
      })
    },

    setTextColor (backgroundColor) {
      // if (backgroundColor) {
      //   return this.$utils.setPathTextColor(backgroundColor)
      // } else {
      //   return '#5d5d5d'
      // }
      return '#5d5d5d'
    },

    toggleChildren (id, length) {
      if (length > 0) {
        let display = document.getElementById(`child-${id}`).style.display === 'none'
          ? 'block'
          : 'none'
        document.getElementById(`node-icon-caret-${id}`).className = display === 'block' && length > 0
          ? 'fas fa-caret-down node-icon-caret'
          : 'fas fa-caret-right node-icon-caret'
        document.getElementById(`child-${id}`).style.display = display
      }
    }
  }
}
</script>
